import { GetSymbolsReturn, GetCurrenciesReturn } from '@web/walter-lib/api'
import { forEach } from 'lodash'
import { SymbolInfo } from '~hooks/useBlocksData'
import { getSymbolCode } from '~utils/data/getSymbolCode'

interface Props {
    isNewRateService: boolean
    currencies?: GetCurrenciesReturn
    symbols?: GetSymbolsReturn
    buyCurrencies?: Set<string>
}

export const processCoins = ({ isNewRateService, currencies, symbols, buyCurrencies }: Props) => {
    if (!isNewRateService && (!symbols || !currencies)) {
        return { blockSymbols: [], info: [] }
    }

    const symbolInfo: SymbolInfo[] = []

    forEach(currencies, (info, currencyCode) => {
        const { symbolCode = '', isReverseSymbol = false } = getSymbolCode(currencyCode, symbols) ?? {}

        symbolInfo.push({
            code: currencyCode,
            symbolCode,
            isReverseSymbol,
            name: info.full_name ?? '',
            isBuyDisabled: !buyCurrencies?.has(currencyCode),
        })
    })

    return { info: symbolInfo }
}
